import { lazyLoadView } from '@utils/LazyLoad'
import { SEARCH_GROUPS } from '@constants/Text'
import {
  buildBackOfficeChildren,
  BACK_OFFICE_DEFAULT_DETAIL_VIEW,
} from '@modules/back-office/utils/build-router/build-router.js'

export default [
  {
    path: '/back-office',
    name: 'back-office',
    redirect: {
      name: 'back-office.imports',
      query: { view: BACK_OFFICE_DEFAULT_DETAIL_VIEW },
    },
    meta: {
      search: {
        title: 'Back Office',
        description: 'Importações e conferência operacional de carteiras',
        keywords: ['back office', 'importações', 'conferência', 'operacional'],
        icon: 'sheet',
        group: SEARCH_GROUPS.GESTAO_PORTFOLIOS,
      },
    },
    component: () =>
      lazyLoadView(
        import('@modules/back-office/views/nav-bar/back-office-nav-bar.vue')
      ),
    children: [
      {
        path: '',
        name: 'back-office.home',
        redirect: {
          name: 'back-office.imports',
          query: { view: BACK_OFFICE_DEFAULT_DETAIL_VIEW },
        },
        component: () =>
          lazyLoadView(
            import('@modules/back-office/views/wrapper/view-wrapper.vue')
          ),
        children: buildBackOfficeChildren({
          namePrefix: 'back-office',
          publicTabs: ['imports', 'suggestions'],
        }),
      },
    ],
  },
]
